<script setup lang="ts">

import {B2B, B2C} from "~/constants/values/client";
const t = useI18n().t
const storeClientType = useClientTypeStore()
const props = defineProps({
  city: {
    type: Object,
    default: () => ({})
  },
  address: {
    type: Object,
    default: () => ({})
  },
})

</script>

<template>

  <p class="mt-3 text-base font-normal text-secondary-800">

    <span class=" rounded-lg  items-center font-medium w-max">
          <span v-if="city.title">
            {{ $t('input_forms.field.address.placeholder.city') }} {{
              city.title
            }}{{ address.street ? ', ' : '' }}
          </span>
      <span v-if="address.street">
            {{ $t('input_forms.field.address.placeholder.street') }} {{
          address.street
        }}{{ (address.entrance || address.floor || (address.house && !address.street?.trim().split(/\s+/).includes(address.house.trim()))) ? ', ' : '' }}
          </span>
    </span>

    <span v-if="(address.house && !address.street?.trim().split(/\s+/).includes(address.house.trim())) || address.entrance || address.floor"
       class=" rounded-lg  items-center font-medium w-max">
      <template v-if="storeClientType===B2B">
            <span v-if="address.office">
              {{ $t('input_forms.field.address.placeholder.office') }} {{ address.office }}
              {{ address.entrance ? ', ' : '' }}
            </span>
      </template>
      <template v-else>
            <span v-if="address.house && !address.street?.trim().split(/\s+/).includes(address.house.trim())">
              {{ address.house }} {{
                $t('input_forms.field.address.placeholder.house')
              }}{{ address.entrance ? ', ' : '' }}
            </span>
      </template>
      <span v-if="address.entrance">
              {{ address.entrance }} {{
          $t('input_forms.field.address.placeholder.entrance')
        }}{{ address.floor ? ', ' : '' }}
            </span>
      <span v-if="address.floor">
              {{ address.floor }} {{
          $t('input_forms.field.address.placeholder.floor')
        }}{{ (address.block || address.flat || address.doorphone) ? ', ' : '' }}
            </span>
    </span>

    <template v-if="address.block || address.flat || address.doorphone">
      <span class=" rounded-lg  items-center font-medium w-max">

        <template v-if="storeClientType===B2B">
            <span v-if="address.block">
              {{ address.block }} {{ $t('input_forms.field.address.placeholder.block') }}
              {{ address.flat ? ', ' : '' }}
            </span>
        </template>
        <span v-if="address.flat">
              {{ address.flat }} {{ $t('input_forms.field.address.placeholder.flat') }}
              {{ address.doorphone ? ', ' : '' }}
            </span>
        <template v-if="storeClientType===B2C">
              <span v-if="address.doorphone">
                {{ address.doorphone }} {{ $t('input_forms.field.address.placeholder.doorphone') }}
              </span>
        </template>
      </span>
    </template>
    <template v-if="address.complex">
      <span class="order-service-form-text mt-3">
        {{ $t('order.location.address_additional') }}
      </span>
      <span class=" rounded-lg  items-center font-medium w-max">
        {{ address.complex }}
      </span>
    </template>
  </p>

</template>

<style scoped>


</style>